import React from "react";

function HsnReport() {
  return <div>HsnReport</div>;
}

export default HsnReport;
